import { expedienteSiniestroService } from "@/_services";
export const expedienteSiniestro = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    entity: {
      data: {},
      status: {},
    },
    patch: {
      data: {},
      status: {},
    },
    leido: {
      data: {},
      status: {},
    },
    excel: {
      data: {},
      status: {},
    },
  },
  mutations: {
    getExpedientesSiniestrosRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getExpedientesSiniestrosSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getExpedientesSiniestrosError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
    getExpedienteSiniestroByIdRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getExpedienteSiniestroByIdSuccess(state, response) {
      state.entity.data = response;
      state.entity.status = {
        loaded: true,
      };
    },
    getExpedienteSiniestroByIdError(state, error) {
      state.entity.data = null;
      state.entity.status = {
        error,
      };
    },
    putExpedienteSiniestroRequest(state) {
      state.patch.status = {
        changing: true,
      };
    },
    putExpedienteSiniestroSuccess(state, response) {
      state.patch.data = response;
      state.patch.status = {
        changed: true,
      };
    },
    putExpedienteSiniestroError(state, error) {
      state.patch.data = null;
      state.patch.status = {
        error,
      };
    },
    putExpedienteSiniestroLeidoRequest(state) {
      state.leido.status = {
        changing: true,
      };
    },
    putExpedienteSiniestroLeidoSuccess(state, response) {
      state.leido.data = response;
      state.leido.status = {
        changed: true,
      };
    },
    putExpedienteSiniestroLeidoError(state, error) {
      state.leido.data = null;
      state.leido.status = {
        error,
      };
    },
    excelRequest(state) {
      state.excel.status = {
        downloading: true,
      };
    },
    excelSuccess(state, pdf) {
      state.excel.data = pdf;
      state.excel.status = {
        downloaded: true,
      };
    },
    excelError(state, error) {
      state.excel.data = null;
      state.excel.status = {
        error,
      };
    },
  },
  actions: {
    getExpedientesSiniestros({ commit }, request) {
      commit("getExpedientesSiniestrosRequest");
      expedienteSiniestroService
        .getExpedientesSiniestros(request.pagination, request.filters)
        .then((response) => {
          commit("getExpedientesSiniestrosSuccess", response);
        })
        .catch((error) => {
          commit("getExpedientesSiniestrosError", error);
        });
    },
    putExpedienteSiniestro({ commit }, request) {
      commit("putExpedienteSiniestroRequest");
      expedienteSiniestroService
        .putExpedienteSiniestro(request.id, request.body)
        .then((res) => {
          commit("putExpedienteSiniestroSuccess", res);
        })
        .catch((error) => {
          commit("putExpedienteSiniestroError", error);
        });
    },
    putExpedienteSiniestroLeido({ commit }, request) {
      commit("putExpedienteSiniestroLeidoRequest");
      expedienteSiniestroService
        .putExpedienteSiniestro(request.id, request.body)
        .then((res) => {
          commit("putExpedienteSiniestroLeidoSuccess", res);
        })
        .catch((error) => {
          commit("putExpedienteSiniestroLeidoError", error);
        });
    },
    getExpedienteSiniestroById({ commit }, id) {
      commit("getExpedienteSiniestroByIdRequest");
      expedienteSiniestroService
        .getExpedienteSiniestroById(id)
        .then((res) => {
          commit("getExpedienteSiniestroByIdSuccess", res);
        })
        .catch((error) => {
          commit("getExpedienteSiniestroByIdError", error);
        });
    },
    getExcel({ commit }, filters) {
      commit("excelRequest");
      expedienteSiniestroService
        .getExcel(filters)
        .then((excel) => {
          commit("excelSuccess", excel);
        })
        .catch((error) => {
          commit("excelError", error);
        });
    },
  },
};
